export default {
    'copy_x': 'Copy {label}',
    'reading_the_servers_version': 'Reading the server\'s version…',
    'could_not_read_the_servers_version_status': 'Could not read the server\'s version status.',
    'retry': 'Retry',
    'version_x_is_available': 'Version {version} is available',
    'this_server_is_up_to_date': 'This server is up to date',
    'could_not_check_for_updates': 'Could not check for updates',
    'new_download_pin_generated': 'New download PIN generated',
    'the_previous_pin_no_longer_works': 'The previous PIN no longer works',
    'could_not_generate_a_download_pin': 'Could not generate a download PIN',
    'this_server': 'This server',
    'what_is_running_here_and_where_it_came_from': 'What is running here and where it came from.',
    'version': 'Version',
    'deployment': 'Deployment',
    'offline_local_server': 'Offline (local server)',
    'online_cloud': 'Online (cloud)',
    'version_source': 'Version source',
    'build': 'Build',
    'built': 'built',
    'facility': 'Facility',
    'dashboard_good_morning': 'Good morning',
    'dashboard_good_afternoon': 'Good afternoon',
    'dashboard_good_evening': 'Good evening',
    'dashboard_good_morning_name': 'Good morning, {name}',
    'dashboard_good_afternoon_name': 'Good afternoon, {name}',
    'dashboard_good_evening_name': 'Good evening, {name}',
    'dashboard_intro_modules': 'Where you left off — every module this hospital runs, one tap away.',
    'dashboard_reports_not_in_plan': 'The figures on this page — today’s census, collections and pending work — come with the Reports module, which is not part of your plan.',
    'dashboard_opd_visit_count': '{count, plural, one {# OPD visit} other {# OPD visits}}',
    'dashboard_pace_none': 'No OPD visits yet today.',
    'dashboard_pace_today': '{visits} so far today.',
    'dashboard_pace_same': '{visits} so far — about the same as this time last week.',
    'dashboard_pace_busier': '{visits} so far — {pct}% busier than this time last week.',
    'dashboard_pace_quieter': '{visits} so far — {pct}% quieter than this time last week.',
    'dashboard_beds_full_free': 'Beds are {pct}% full — {free} free.',
    'dashboard_collected_so_far': '{amount} collected so far today.',
    'dashboard_patients_waiting_for_you': '{count, plural, one {# patient is waiting for you.} other {# patients are waiting for you.}}',
    'dashboard_nobody_waiting': 'Nobody is waiting for you right now.',
    'dashboard_pulling_together': 'Pulling together today…',
    'dashboard_where_you_left_off': 'Where you left off.',
    'dashboard_updated': 'Updated {when}',
    'dashboard_refresh': 'Refresh the figures',
    'dashboard_hospital_today': 'Hospital today',
    'dashboard_load_failed': 'The hospital figures could not be loaded. Try refreshing in a moment.',
    'dashboard_my_day': 'My day',
    'dashboard_jump_back_in': 'Jump back in',
    'dashboard_loading': 'Loading the figures',
    'dashboard_opd_visits_today': 'OPD visits today',
    'dashboard_last_week_by_now': 'Last week by now: {count}',
    'dashboard_new_patients': 'New patients',
    'dashboard_collected_today': 'Collected today',
    'dashboard_billed_today': '{amount} billed today',
    'dashboard_inpatients_now': 'Inpatients now',
    'dashboard_admitted_discharged_today': '{admitted} admitted · {discharged} discharged today',
    'dashboard_lab_tests_pending': 'Lab tests pending',
    'dashboard_ordered_not_verified': 'Ordered, not yet verified',
    'dashboard_active_er_cases': 'Active ER cases',
    'dashboard_awaiting_disposition': 'Awaiting a disposition',
    'dashboard_opd_visits': 'OPD visits',
    'dashboard_admissions': 'Admissions',
    'dashboard_discharges': 'Discharges',
    'dashboard_patient_flow': 'Patient flow',
    'dashboard_patient_flow_hint': 'Last 14 days — tap a series to hide it',
    'dashboard_todays_appointments': 'Today’s appointments',
    'dashboard_todays_appointments_hint': 'Where everyone booked for today stands',
    'dashboard_queue': 'Queue',
    'dashboard_stage_expected': 'Yet to arrive',
    'dashboard_stage_waiting': 'Waiting',
    'dashboard_stage_with_doctor': 'With doctor',
    'dashboard_stage_seen': 'Seen',
    'dashboard_stage_no_show': 'No-show',
    'dashboard_stage_cancelled': 'Cancelled',
    'dashboard_booked_today': 'booked today',
    'dashboard_no_appointments_today': 'No appointments booked for today.',
    'dashboard_opd_by_hour': 'OPD visits by hour',
    'dashboard_opd_by_hour_hint': 'Bars are today, the dashed line a typical day.',
    'dashboard_opd_by_hour_peak': 'Bars are today, the dashed line a typical day. Usually busiest around {hour}.',
    'dashboard_bed_occupancy': 'Bed occupancy',
    'dashboard_beds_free_now': '{count, plural, one {# bed free right now} other {# beds free right now}}',
    'dashboard_no_beds_yet': 'No beds set up yet',
    'dashboard_bed_board': 'Bed board',
    'dashboard_add_wards_hint': 'Add wards and beds to see occupancy here.',
    'dashboard_nearly_full': 'Nearly full',
    'dashboard_filling_up': 'Filling up',
    'dashboard_room_to_admit': 'Room to admit',
    'dashboard_beds_of_total': '{occupied} of {total} beds',
    'dashboard_billed_and_collected': 'Billed and collected',
    'dashboard_last_14_days': 'Last 14 days',
    'dashboard_collected_against_billed': 'Last 14 days — {collected} collected against {billed} billed ({pct}%)',
    'dashboard_reports': 'Reports',
    'dashboard_billed': 'Billed',
    'dashboard_collected': 'Collected',
    'dashboard_collected_center': 'collected',
    'dashboard_todays_collections': 'Today’s collections',
    'dashboard_todays_collections_hint': 'By payment method, net of refunds',
    'dashboard_nothing_collected': 'Nothing collected yet today.',
    'dashboard_revenue_by_department': 'Revenue by department',
    'dashboard_net_billed_30_days': 'Net billed, last 30 days',
    'dashboard_no_billing_30_days': 'No billing in the last 30 days.',
    'dashboard_top_diagnoses': 'Top diagnoses',
    'dashboard_top_diagnoses_hint': 'Most frequent ICD codes, last 30 days',
    'dashboard_no_diagnoses_30_days': 'No coded diagnoses in the last 30 days.',
    'dashboard_patients_waiting': 'Patients waiting',
    'dashboard_arrived_not_seen': 'Arrived, not yet seen',
    'dashboard_imaging_pending': 'Imaging pending',
    'dashboard_ordered_not_reported': 'Ordered, not yet reported',
    'dashboard_batches_expiring': 'Batches expiring soon',
    'dashboard_batches_expiring_hint': 'In stock, expiring within 30 days',
    'dashboard_needs_attention': 'Needs attention',
    'dashboard_needs_attention_hint': 'Work waiting on someone right now',
    'dashboard_untriaged': 'Untriaged',
    'dashboard_lab_turnaround': 'Lab turnaround',
    'dashboard_lab_turnaround_hint': 'Sample collected to result verified',
    'dashboard_er_door_to_doctor': 'ER door to doctor',
    'dashboard_er_door_to_doctor_hint': 'Arrival to first doctor contact',
    'dashboard_no_show_rate': 'No-show rate',
    'dashboard_no_show_rate_hint': 'Booked appointments that were missed',
    'dashboard_readmissions': '30-day readmissions',
    'dashboard_readmissions_hint': 'Back within 30 days of discharge',
    'dashboard_average_stay': 'Average stay',
    'dashboard_average_stay_hint': 'Admission to discharge',
    'dashboard_days': '{count, plural, one {# day} other {# days}}',
    'dashboard_quality': 'Quality at a glance',
    'dashboard_quality_hint': 'The numbers a hospital is judged on, last 30 days',
    'dashboard_minutes': '{minutes} min',
    'dashboard_hours': '{hours} h',
    'dashboard_hours_minutes': '{hours} h {minutes} min',
    'dashboard_compared_last_week': 'Compared with the same time last week',
    'dashboard_today': 'Today',
    'dashboard_typical_day': 'A typical day',
    'dashboard_up_next_with_you': 'With you',
    'dashboard_up_next_confirmed': 'Confirmed',
    'dashboard_up_next_expected': 'Expected',
    'dashboard_consultations_today': 'Consultations today',
    'dashboard_completed_still_expected': '{seen} completed · {expected} still expected',
    'dashboard_waiting_for_you': 'Waiting for you',
    'dashboard_arrived_ready_to_be_seen': 'Arrived and ready to be seen',
    'dashboard_nobody_waiting_now': 'Nobody waiting right now',
    'dashboard_average_consult': 'Average consult',
    'dashboard_opened_to_closed_today': 'Opened to closed, today',
    'dashboard_my_share_today': 'My share today',
    'dashboard_on_what_patients_paid': 'On what patients have paid so far',
    'dashboard_my_consultations': 'My consultations',
    'dashboard_my_consultations_hint': '{total} in the last 14 days — about {average} on a working day',
    'dashboard_consultations': 'Consultations',
    'dashboard_up_next': 'Up next',
    'dashboard_up_next_hint': 'Your patients for the rest of today',
    'dashboard_my_queue': 'My queue',
    'dashboard_nobody_else_booked': 'Nobody else is booked with you today.',
    'health': 'Health',
    'healthy': 'Healthy',
    'database_unreachable': 'Database unreachable',
    'sync_in_progress': 'Sync in progress',
    'licence_and_activation': 'Licence & activation',
    'the_cloud_check_in_that_keeps_this_install': 'The cloud check-in that keeps this install writable.',
    'activation': 'Activation',
    'not_applicable_on_the_cloud': 'Not applicable on the cloud',
    'last_check_in': 'Last check-in',
    'lock_state': 'Lock state',
    'grace_period': 'Grace period',
    'days': 'days',
    'x_days_until_read_only_without_a_check_in': '{daysUntilLock} days until read-only without a check-in',
    'download_pin': 'Download PIN',
    'offline_mode_is_not_enabled_for_this_facility': 'Offline mode is not enabled for this facility — contact the owner.',
    'together_with_the_facility_code': 'Together with the facility code',
    'this_pin_unlocks_the_offline_installer_download': ', this PIN unlocks the offline installer download on the public landing page. It is shown only once.',
    'download_pin_2': 'download PIN',
    'generate_another_pin': 'Generate another PIN',
    'generate_a_new_download_pin': 'Generate a new download PIN',
    'updates': 'Updates',
    'the_server_asks_the_cloud_for_new_versions_on': 'The server asks the cloud for new versions on every check-in. Updates are never applied silently — an administrator starts them from here or from the banner.',
    'the_cloud_deployment_is_updated_by_the_platform': 'The cloud deployment is updated by the platform owner.',
    'latest_known': 'Latest known',
    'required': 'Required',
    'up_to_date_as_of_the_last_check_in': 'Up to date as of the last check-in',
    'last_update': 'Last update',
    'failed_and_rolled_back': 'Failed and rolled back',
    'no_failed_update_on_record': 'No failed update on record',
    'release_notes': 'Release notes',
    'check_for_updates_now': 'Check for updates now',
    'update_to': 'Update to',
    'x_to_x': '{start} to {end}',
    'could_not_check_the_audit_trail': 'Could not check the audit trail',
    'could_not_export_the_audit_trail': 'Could not export the audit trail',
    'audit_log': 'Audit log',
    'every_create_update_and_delete_on_clinical_and': 'Every create, update and delete on clinical and financial records',
    'export_csv': 'Export CSV',
    'verify_integrity': 'Verify integrity',
    'the_audit_trail_verifies': 'The audit trail verifies',
    'the_audit_chain_does_not_verify': 'The audit chain does not verify',
    'x_entries_checked_none_altered': '{rowsChecked} entries checked, none altered.',
    'x_of_x_entries_fail_verification_entries_have': '{length} of {rowsChecked} entries fail verification. Entries have been altered or removed outside the application. Investigate immediately.',
    'checked_the_last_30_days_pick_dates_above_to': 'Checked the last 30 days. Pick dates above to check another range.',
    'from': 'From',
    'to': 'To',
    'person': 'Person',
    'clear': 'Clear',
    'search_staff': 'Search staff',
    'record_type': 'Record type',
    'all_records': 'All records',
    'record_id': 'Record id',
    'action': 'Action',
    'all_actions': 'All actions',
    'no_audit_entries_match': 'No audit entries match.',
    'when': 'When',
    'system': 'system',
    'record': 'Record',
    'ip': 'IP',
    'reason': 'Reason',
    'load_more': 'Load more',
    'x_on_x': '{action} on {entityType}',
    'request_id': 'Request id',
    'ip_address': 'IP address',
    'sequence': 'Sequence',
    'hash': 'Hash',
    'before': 'Before',
    'after': 'After',
    'changed_fields': 'Changed fields',
    'field': 'Field',
    'billing_settings_saved': 'Billing settings saved',
    'could_not_save_the_settings': 'Could not save the settings',
    'payments_and_cash': 'Payments and cash',
    'require_a_reference_for_card_transfer_wallet': 'Require a reference for card, transfer, wallet and gateway payments.',
    'the_slip_or_transaction_number_must_be_typed': 'The slip or transaction number must be typed before the payment is saved.',
    'require_an_open_cashier_shift_to_sell_or_take': 'Require an open cashier shift to sell or take cash.',
    'every_cash_movement_is_then_tied_to_a_drawer': 'Every cash movement is then tied to a drawer that is counted at the end of the shift.',
    'allow_cash_to_be_taken_or_paid_out_when_nobody': 'Allow cash to be taken or paid out when nobody has a shift open.',
    'switch_off_to_refuse_cash_refunds_and_advances': 'Switch off to refuse cash refunds and advances that have no drawer to come out of.',
    'blind_cash_count_hide_the_expected_cash_from': 'Blind cash count: hide the expected cash from the cashier until the count is submitted.',
    'supervisors_and_finance_readers_still_see_it': 'Supervisors and finance readers still see it. After the shift is closed everyone sees the expected cash and the difference.',
    'save_billing_settings': 'Save billing settings',
    'tax_registration_saved': 'Tax registration saved',
    'please_check': 'Please check',
    'could_not_save_the_tax_registration': 'Could not save the tax registration',
    'could_not_save_the_setting': 'Could not save the setting',
    'this_account_has_no_branch_so_there_is_no_tax': 'This account has no branch, so there is no tax registration to show.',
    'tax': 'Tax',
    'branch': 'Branch',
    'loading': 'Loading…',
    'set_this_branchs_country_in_branches_before': 'Set this branch\'s country in Branches before recording its tax registration.',
    'country_and_currency_locked_by_this_registration': 'Country and currency locked by this registration',
    'legal_name_english': 'Legal name (English)',
    'as_on_the_registration_defaults_to_the_display': 'As on the registration. Defaults to the display name.',
    'saving_a_registration_locks_this_branchs': 'Saving a registration locks this branch\'s country and currency, because invoices issued from now on depend on them.',
    'save_tax_registration': 'Save tax registration',
    'print_x_beside_english_on_tax_invoices_and': 'Print {secondaryName} beside English on tax invoices and credit notes.',
    'applies_to_every_branch_in_this_country': 'Applies to every branch in this country.',
    'tax_invoices_and_credit_notes_always_print_in': 'Tax invoices and credit notes always print in English and {secondaryName} here; the law requires it.',
    'prescriptions_dispensing_labels_and_discharge': 'Prescriptions, dispensing labels and discharge summaries given to the patient.',
    'branch_approved': 'Branch approved',
    'x_is_open_for_sign_in': '{name} is open for sign-in.',
    'could_not_approve_the_branch': 'Could not approve the branch',
    'approve_branch': 'Approve branch',
    'branches': 'Branches',
    'sites_departments_and_units': 'Sites, departments and units',
    'add_store': 'Add store',
    'add_standard_departments': 'Add standard departments',
    'add_department': 'Add department',
    'add_standard_specialties': 'Add standard specialties',
    'add_specialty': 'Add specialty',
    'add_branch': 'Add branch',
    'departments': 'Departments',
    'specialties': 'Specialties',
    'stores': 'Stores',
    'code': 'Code',
    'name': 'Name',
    'pending_owner_approval': 'Pending Owner approval',
    'sub_branch_of': 'Sub-branch of',
    'city': 'City',
    'country': 'Country',
    'not_set': 'Not set',
    'phone': 'Phone',
    'staff': 'Staff',
    'status': 'Status',
    'active': 'active',
    'inactive': 'inactive',
    'status_active': 'Active',
    'status_inactive': 'Inactive',
    'status_everyone': 'Everyone',
    'edit': 'Edit',
    'laboratory_test_sections_are_set_in_the_test': 'Laboratory test sections are set in the Test catalogue, not here.',
    'no_departments_yet_add_the_standard_ones_to': 'No departments yet. Add the standard ones to start.',
    'department': 'Department',
    'kind': 'Kind',
    'no_specialties_yet_add_the_standard_ones_to': 'No specialties yet. Add the standard ones to start.',
    'specialty': 'Specialty',
    'nphies_practice_code': 'NPHIES practice code',
    'a_store_is_a_stock_location_the_main_pharmacy': 'A store is a stock location — the main pharmacy, an ER or theatre pharmacy, a ward satellite. Stock is held per store, so closing one is refused while it still holds any.',
    'no_stores_yet': 'No stores yet.',
    'store': 'Store',
    'type': 'Type',
    'ward': 'Ward',
    'sells': 'Sells',
    'branch_updated': 'Branch updated',
    'branch_created': 'Branch created',
    'its_staff_can_sign_in_to_it_once_the_owner': 'Its staff can sign in to it once the Owner approves it. You can set it up in the meantime.',
    'edit_x': 'Edit {name}',
    'add_a_branch': 'Add a branch',
    'the_city_is_what_patients_search_for_on_the': 'The city is what patients search for on the public directory',
    'the_code_prefixes_mrns_issued_at_this_site': 'The code prefixes MRNs issued at this site',
    'cancel': 'Cancel',
    'save_changes': 'Save changes',
    'create_branch': 'Create branch',
    'sits_under': 'Sits under',
    'leave_empty_for_a_main_branch_a_sub_branch_gets': 'Leave empty for a main branch. A sub-branch gets its main branch\'s code with a number, e.g. ABC1.',
    'a_main_branch': '— A main branch —',
    'fixed_while_it_has_sub_branches_their_codes': 'Fixed while it has sub-branches — their codes were made from it',
    'address': 'Address',
    'locked_this_branch_already_has_its_tax': 'Locked: this branch already has its tax registration recorded',
    'decides_the_currency_tax_rules_and_id_documents': 'Decides the currency, tax rules and ID documents. It locks once tax details or the first bill are recorded.',
    'select_a_country': 'Select a country…',
    'currency': 'Currency',
    'follows_the_country': 'Follows the country',
    'emirate': 'Emirate',
    'province_or_region': 'Province or region',
    'decides_the_health_regulator_and_the_claims_add': 'Decides the health regulator and the claims add-ons for this branch',
    'needed_where_the_branch_is_registered_for': 'Needed where the branch is registered for provincial tax',
    'select': 'Select…',
    'name_x': 'Name ({localLanguage})',
    'printed_beside_the_english_name_on_bilingual': 'Printed beside the English name on bilingual documents',
    'address_x': 'Address ({localLanguage})',
    'letterhead_line': 'Letterhead line',
    'printed_on_this_branchs_documents_under_the': 'Printed on this branch\'s documents under the letterhead — e.g. its licence number',
    'what_this_branch_is': 'What this branch is',
    'for_the_list_and_for_suggesting_its_standard': 'For the list and for suggesting its standard departments. It does not limit anything.',
    'main_category': 'Main category',
    'pick_the_main_categories_first_their_sub': 'Pick the main categories first; their sub-categories appear underneath.',
    'x_sub_categories': '{name} sub-categories',
    'its_main_category_was_filled_in_from_its_sub': 'Its main category was filled in from its sub-categories and is kept when you save.',
    'branch_admin_role_added': 'Branch Admin role added',
    'give_it_to_someone_under_staff_and_roles': 'Give it to someone under Staff & roles, limited to their branch',
    'could_not_add_the_role': 'Could not add the role',
    'running_more_than_one_branch': 'Running more than one branch?',
    'the_branch_admin_role_lets_someone_run_one': 'The Branch Admin role lets someone run one branch — its staff, departments and settings — without reaching the others.',
    'add_the_branch_admin_role': 'Add the Branch Admin role',
    'not_now': 'Not now',
    'x_switched_off': '{name} switched off',
    'x_switched_on': '{name} switched on',
    'could_not_change_the_department': 'Could not change the department',
    'deactivate': 'Deactivate',
    'reactivate': 'Reactivate',
    'nothing_new_to_add': 'Nothing new to add',
    'x_department_s_added': '{added} department(s) added',
    'the_usual_departments_for_the_modules_you_hold': 'The usual departments for the modules you hold. Adding one twice changes nothing.',
    'add': 'Add',
    'department_2': 'department',
    'select_a_branch': 'Select a branch…',
    'this_branch_already_has_every_standard': 'This branch already has every standard department.',
    'or_copy_the_departments_of_another_branch': 'Or copy the departments of another branch',
    'choose_a_branch': 'Choose a branch…',
    'copy': 'Copy',
    'specialty_updated': 'Specialty updated',
    'specialty_added': 'Specialty added',
    'add_a_specialty': 'Add a specialty',
    'printed_under_a_doctors_name_a_specialty_is': 'Printed under a doctor\'s name. A specialty is switched off, never deleted, because staff and history point at it.',
    'uppercase_letters_digits_and_underscores': 'Uppercase letters, digits and underscores',
    'sent_with_claims_for_this_specialty': 'Sent with claims for this specialty',
    'in_use': 'In use',
    'common_specialties_not_yet_on_your_list': 'Common specialties not yet on your list',
    'every_standard_specialty_is_already_on_your_list': 'Every standard specialty is already on your list.',
    'select_none': 'Select none',
    'select_all': 'Select all',
    'department_updated': 'Department updated',
    'department_created': 'Department created',
    'add_a_department': 'Add a department',
    'create_department': 'Create department',
    'store_closed': 'Store closed',
    'store_reopened': 'Store reopened',
    'could_not_close_the_store': 'Could not close the store',
    'could_not_reopen_the_store': 'Could not reopen the store',
    'close': 'Close',
    'reopen': 'Reopen',
    'store_updated': 'Store updated',
    'store_created': 'Store created',
    'add_a_store': 'Add a store',
    'a_store_cannot_be_moved_to_another_branch_its': 'A store cannot be moved to another branch — its stock and ledger stay where they are.',
    'stock_is_counted_per_store_so_create_one_per': 'Stock is counted per store, so create one per physical dispensing point.',
    'save_store': 'Save store',
    'create_store': 'Create store',
    'dispenses_to_patients_appears_in_the_pharmacy': 'Dispenses to patients (appears in the pharmacy counter)',
    'download_requested': 'Download requested',
    'could_not_request_the_download': 'Could not request the download',
    'could_not_start_the_download': 'Could not start the download',
    'download_all_data': 'Download all data',
    'a_copy_of_every_record_and_stored_file_of_this': 'A copy of every record and stored file of this facility, as a single zip. Passwords, authenticator secrets and integration credentials are left out. Once a day.',
    'download': 'Download',
    'your_6_digit_authenticator_code': 'Your 6-digit authenticator code',
    'authenticator_code': 'Authenticator code',
    'request_a_full_download': 'Request a full download',
    'letterhead_saved': 'Letterhead saved',
    'could_not_save_the_letterhead': 'Could not save the letterhead',
    'letterhead_removed': 'Letterhead removed',
    'could_not_remove_the_letterhead': 'Could not remove the letterhead',
    'letterhead_image': 'Letterhead image',
    'a_scanned_or_designed_banner_printed_across_the': 'A scanned or designed banner printed across the top of reports instead of the text letterhead. Set one for the whole hospital, and another for a branch if it prints its own.',
    'for': 'For',
    'the_whole_hospital': 'The whole hospital',
    'image': 'Image',
    'an_image_is_set_choose_a_file_to_replace_it': 'An image is set; choose a file to replace it',
    'png_jpeg_or_webp_up_to_1_mb_at_least_three': 'PNG, JPEG or WebP, up to 1 MB, at least three times wider than tall',
    'lines_under_the_image': 'Lines under the image',
    'up_to_four_one_per_line': 'Up to four, one per line',
    'footer': 'Footer',
    'up_to_300_characters': 'Up to 300 characters',
    'save_letterhead': 'Save letterhead',
    'remove': 'Remove',
    'x_saved': '{label} saved',
    'could_not_save': 'Could not save',
    'could_not_run_the_test': 'Could not run the test',
    'in_your_plan': 'In your plan',
    'not_in_your_plan': 'Not in your plan',
    'waiting_to_send': 'waiting to send',
    'this_service_is_not_part_of_your_plan_ask_the': 'This service is not part of your plan. Ask the platform owner to switch it on for your account.',
    'this_facility_runs_on_its_own_server_requests': 'This facility runs on its own server. Requests are sent from that server using its own internet connection, so they can only be set up and used there.',
    'not_ready_yet': 'Not ready yet:',
    'use_this_service_from_this_computer': 'Use this service from this computer',
    'environment': 'Environment',
    'test_in_the_sandbox_first_switch_to_production': 'Test in the sandbox first; switch to production when the service has approved this facility',
    'sandbox_testing': 'Sandbox (testing)',
    'production_live': 'Production (live)',
    'service_address': 'Service address',
    'given_by_the_service_when_this_facility_is': 'Given by the service when this facility is registered. Must start with https://. Changing it, the message path or the token address removes the saved credentials, which must then be entered again',
    'use_the_default': 'Use the default',
    'credentials_stored_encrypted_on_this_computer': 'Credentials — stored encrypted on this computer only, never shown again',
    'last_test': 'Last test',
    'reachable': 'reachable',
    'failed': 'failed',
    'save': 'Save',
    'test_the_connection': 'Test the connection',
    'could_not_do_that': 'Could not do that',
    'could_not_open_it': 'Could not open it',
    'what_was_sent': 'What was sent',
    'every_status': 'Every status',
    'refresh': 'Refresh',
    'nothing_has_been_sent_to_an_external_service_yet': 'Nothing has been sent to an external service yet.',
    'service': 'Service',
    'request': 'Request',
    'detail': 'Detail',
    'x_ms': '{latencyMs} ms',
    'view': 'View',
    'try_again': 'Try again',
    'the_message_text_itself_is_not_kept_this_is_the': 'The message text itself is not kept. This is the record of it.',
    'message_id': 'Message id',
    'summary': 'Summary',
    'fingerprint': 'Fingerprint',
    'size': 'Size',
    'x_bytes': '{bytes} bytes',
    'tries': 'Tries',
    'created': 'Created',
    'sent': 'Sent',
    'finished': 'Finished',
    'problem': 'Problem',
    'mapping_saved': 'Mapping saved',
    'could_not_save_the_mapping': 'Could not save the mapping',
    'could_not_remove_it': 'Could not remove it',
    'choose': 'Choose…',
    'code_system': 'Code system',
    'their_code': 'Their code',
    'their_name_for_it_optional': 'Their name for it (optional)',
    'drugs_and_products': 'Drugs and products',
    'billed_services': 'Billed services',
    'that_have_no_insurer_code_yet': 'that have no insurer code yet',
    'a_claim_carrying_one_of_these_cannot_be_sent': 'A claim carrying one of these cannot be sent. Choose one, then fill in the code the insurer uses for it.',
    'map_this': 'Map this',
    'show_more': 'Show more',
    'nothing_mapped_yet': 'Nothing mapped yet.',
    'ours': 'Ours',
    'theirs': 'Theirs',
    'system_2': 'System',
    'requests_to_nphies_and_wasfaty_are_sent_by_this': 'Requests to NPHIES and Wasfaty are sent by this computer over its own internet connection, one request at a time as staff use them. If the connection is down, checks that need an answer now say so at once. NPHIES claims and pre-authorisations wait in a queue and are sent by themselves when the connection comes back; a Wasfaty request is never queued, because its 25-minute hold would run out while it waited.',
    'code_mapping': 'Code mapping —',
    'new_documents_print_with_it': 'New documents print with it',
    'logo_uploaded': 'Logo uploaded',
    'could_not_upload_the_logo': 'Could not upload the logo',
    'logo_removed': 'Logo removed',
    'could_not_remove_the_logo': 'Could not remove the logo',
    'letterhead_and_logo': 'Letterhead and logo',
    'logo': 'Logo',
    'png_jpeg_or_webp_up_to_512_kb_printed_on': 'PNG, JPEG or WebP, up to 512 KB. Printed on documents and shown on the sign-in page.',
    'upload_your_logo_to_print_it_a_link_to_another': 'Upload your logo to print it. A link to another website is not printed.',
    'layout': 'Layout',
    'one_language': 'One language',
    'two_languages_second_one_on_the_right': 'Two languages (second one on the right)',
    'lines': 'Lines',
    'second_language_lines': 'Second-language lines',
    'facility_name_as_printed': 'Facility name as printed',
    'address_phone_licence': 'Address, phone, licence…',
    'rtl': 'RTL',
    'ltr': 'LTR',
    'print_the_branch_address': 'Print the branch address',
    'print_the_branch_phone': 'Print the branch phone',
    'print_the_branch_licence_line_set_on_each_branch': 'Print the branch licence line (set on each branch)',
    'up_to_300_characters_printed_at_the_bottom_of': 'Up to 300 characters, printed at the bottom of documents',
    'preview': 'Preview',
    'active_2': 'Active',
    'closed': 'Closed',
    'read_only': 'Read-only',
    'trial': 'Trial',
    'grace_extended_until_x': 'Grace extended until {until}',
    'the_code_was_not_accepted': 'The code was not accepted',
    'paste_the_code_support_gave_you': 'Paste the code support gave you',
    'offline_grace_code': 'Offline grace code',
    'apply_code': 'Apply code',
    'licence': 'Licence',
    'what_this_facility_is_licensed_for': 'What this facility is licensed for.',
    'reading_the_licence': 'Reading the licence…',
    'the_licence_could_not_be_read': 'The licence could not be read.',
    'state': 'State',
    'trial_ends': 'trial ends',
    'paid_until': 'paid until',
    'packages': 'Packages',
    'modules': 'Modules',
    'removed': 'Removed',
    'records_stay_readable_and_can_be_exported': '— records stay readable and can be exported',
    'add_ons': 'Add-ons',
    'on': 'on',
    'off': 'off',
    'offline_grace': 'Offline grace',
    'x_days_without_a_check_in': '{graceDays} days without a check-in',
    'extended_until': 'Extended until',
    'grace_code_valid_until': 'Grace code valid until',
    'grace_code': 'Grace code',
    'for_an_internet_outage_support_can_give_you_a': 'For an internet outage: support can give you a signed code that keeps this server writable for up to 7 days.',
    'technical_details': 'Technical details',
    'licence_version': 'Licence version:',
    'received': 'Received:',
    'source': 'Source:',
    'signed_licence': 'signed licence',
    'settings_on_this_server': 'settings on this server',
    'request_a_change': 'Request a change',
    'send_payment_proof': 'Send payment proof',
    'needs_this_server_to_be_online_without_internet': 'Needs this server to be online; without internet, call or email support.',
    'x_saved_2': '{name} saved',
    'outside_saudi_arabia_not_sent_to_nphies': 'Outside Saudi Arabia — not sent to NPHIES',
    'provider_licence': 'Provider licence',
    'provider_type': 'Provider type',
    'location_licence': 'Location licence',
    'location_role': 'Location role',
    'could_not_start_the_session': 'Could not start the session',
    'certification_session': 'Certification session',
    'while_a_session_is_on_the_last_20_messages': 'While a session is on, the last 20 messages exchanged with the test exchange are kept in this server’s memory for 60 minutes, for the certification evidence. Nothing is written to the database. Only a Super Admin can start one, and never against production.',
    'on_until': 'On until',
    'stop': 'Stop',
    'start_a_session': 'Start a session',
    'nothing_exchanged_yet_in_this_session': 'Nothing exchanged yet in this session.',
    'message': 'Message',
    'could_not_download_it': 'Could not download it',
    'nphies_message_archive': 'NPHIES message archive',
    'every_message_sent_to_and_received_from_nphies': 'Every message sent to and received from NPHIES, exactly as exchanged, kept encrypted on this server and never copied to the online system. A message is opened only when you download it, and every download is recorded.',
    'nothing_has_been_exchanged_yet': 'Nothing has been exchanged yet.',
    'about': 'About',
    'newest': 'Newest',
    'older': 'Older',
    'could_not_save_it': 'Could not save it',
    'pre_authorisation_per_department': 'Pre-authorisation per department',
    'automatic_follows_the_facility_setting_manual': 'Automatic follows the facility setting. Manual never sends by itself: the department’s visits wait on the manual worklist for someone to complete and send them.',
    'no_clinical_departments': 'No clinical departments.',
    'mode': 'Mode',
    'facility_default': 'Facility default',
    'automatic': 'Automatic',
    'manual': 'Manual',
    'insurance_authorisation_mode': 'Insurance pre-authorisation',
    'facility_default_for_every_payer': 'Facility default for every payer',
    'decided_by_the_payer': 'Decided by the payer: automatic for an NPHIES payer when auto-send is on, otherwise manual',
    'automatic_sends_the_request_when_orders_are': 'Automatic sends the request when orders are signed and when the consultation closes. Manual never sends by itself: the visit waits on the manual worklist until the doctor or the insurance desk presses Send for authorisation. A department setting overrides the facility default.',
    'department_overrides': 'Per department',
    'nphies_implementation_team': 'NPHIES — implementation team',
    'licences_per_branch': 'Licences per branch',
    'each_branch_sends_under_its_own_provider': 'Each branch sends under its own provider licence; a branch without one uses the licence set on the connection.',
    'practice_code_per_specialty': 'Practice code per specialty',
    'no_specialties_on_file': 'No specialties on file.',
    'practice_code': 'Practice code',
    'template_saved': 'Template saved',
    'could_not_save_the_template': 'Could not save the template',
    'template_removed': 'Template removed',
    'could_not_remove_the_template': 'Could not remove the template',
    'reply_templates_for_insurer_requests': 'Reply templates for insurer requests',
    'add_a_template': 'Add a template',
    'title_for_example_discharge_summary_attached': 'Title, for example Discharge summary attached',
    'the_reply_text': 'The reply text',
    'offered_when_answering': 'Offered when answering',
    'no_reply_templates_yet': 'No reply templates yet.',
    'title': 'Title',
    'text': 'Text',
    'numbering_saved': 'Numbering saved',
    'the_next_number_of_each_changed_series_uses_the': 'The next number of each changed series uses the new pattern',
    'could_not_save_the_numbering': 'Could not save the numbering',
    'number_series': 'Number series',
    'you_can_view_the_numbering_but_not_change_it': 'You can view the numbering but not change it.',
    'changing_a_pattern_affects_the': 'Changing a pattern affects the',
    'next': 'next',
    'number_only_nothing_already_issued_is': 'number only — nothing already issued is renumbered, and counters keep counting.',
    'series': 'Series',
    'pattern': 'Pattern',
    'example': 'Example',
    'archived_module_read_only': 'Archived module — read-only',
    'undo': 'Undo',
    'never_restarts': 'never restarts',
    'restarts_x': 'restarts {value}',
    'restarts_daily': 'restarts every day',
    'restarts_monthly': 'restarts every month',
    'restarts_yearly': 'restarts every year',
    'save_x_changes': '{count, plural, one {Save # change} other {Save # changes}}',
    'number_series_mrn': 'Patient MRN',
    'number_series_invoice': 'Invoice',
    'number_series_estimate': 'Estimate',
    'number_series_receipt': 'Receipt and refund voucher',
    'number_series_credit_note': 'Credit note',
    'number_series_payer_invoice': 'Insurer tax invoice',
    'number_series_token': 'OPD token',
    'number_series_prescription': 'Prescription',
    'number_series_certificate': 'Medical certificate',
    'number_series_accession': 'Lab accession',
    'number_series_admission': 'Admission',
    'number_series_er_case': 'Emergency case number',
    'number_series_therapy': 'Therapy session',
    'number_series_claim': 'Insurance claim',
    'number_series_blood_donor': 'Blood donor',
    'number_series_blood_unit': 'Blood bag',
    'number_series_grn': 'Goods received note',
    'number_series_purchase_order': 'Purchase order',
    'number_series_supplier_payment': 'Supplier payment',
    'number_series_purchase_return': 'Purchase return (debit note)',
    'number_series_stock_take': 'Stock count sheet',
    'number_series_stock_adjustment': 'Stock adjustment request',
    'number_series_indent': 'Ward indent',
    'number_series_online_order': 'Online order',
    'number_series_maintenance_ticket': 'Maintenance ticket',
    'number_series_journal': 'Journal voucher',
    'number_series_employee': 'Employee number',
    'number_series_mrn_hint': 'One lifetime number per patient, across every branch',
    'number_series_estimate_hint': 'Own series, so tax invoice numbers have no gaps',
    'number_series_receipt_hint': 'One series for payments, advances and refunds',
    'number_series_payer_invoice_hint': 'Monthly invoices to insurers and their credit notes',
    'number_series_token_hint': 'Counted per doctor',
    'number_series_certificate_hint': 'Sick leave, fitness and other certificates',
    'number_series_accession_hint': 'Printed on the specimen label',
    'number_series_blood_donor_hint': 'One number per donor, kept for every donation',
    'number_series_blood_unit_hint': 'Printed on the bag label',
    'number_series_maintenance_ticket_hint': 'Breakdown, preventive and calibration tickets',
    'number_token_seq': 'Running counter, zero-padded to the width given',
    'number_token_yyyy': 'Four-digit year',
    'number_token_yy': 'Two-digit year',
    'number_token_mm': 'Two-digit month',
    'number_token_dd': 'Two-digit day',
    'number_token_branch': 'Branch code, e.g. MAIN',
    'number_token_check': 'Check digit — a typo or two swapped digits is caught when the number is keyed in',
    'number_pattern_no_counter': 'The pattern needs a {token} counter',
    'number_pattern_unknown_token': 'Unknown token {token}',
    'number_pattern_bad_characters': 'Only letters, digits, - / . _ and spaces are allowed around tokens',
    'number_pattern_needs_year': 'This counter restarts every year, so the pattern must show the year',
    'number_pattern_needs_year_month': 'This counter restarts every month, so the pattern must show the year and month',
    'number_pattern_needs_date': 'This counter restarts every day, so the pattern must show the date',
    'tokens': 'Tokens',
    'anything_outside_braces_is_printed_as_is': 'Anything outside braces is printed as-is.',
    'gives': 'gives',
    'a_receptionist_who_mistypes_a_digit_is_told_so': ': a receptionist who mistypes a digit is told so instead of opening the wrong file.',
    'settings_saved': 'Settings saved',
    'clinical_settings_saved': 'Clinical settings saved',
    'loading_settings': 'Loading settings…',
    'settings': 'Settings',
    'changes_are_made_on_your_facilitys_own_server': 'Changes are made on your facility\'s own server.',
    'clinical_policy': 'Clinical policy',
    'free_follow_up_window_days': 'Free follow-up window (days)',
    'follow_up_pricing_is_set_under_charge_master': 'Follow-up pricing is set under Charge Master, Consultation fees',
    'a_revisit_inside_this_window_is_not_charged': 'A revisit inside this window is not charged again',
    'appointment_reminders_hours_before': 'Appointment reminders (hours before)',
    'one_to_four_whole_hours_e_g_24_2_each_patient': 'One to four whole hours, e.g. 24, 2. Each patient gets one message, and never for a time that has passed',
    'ward_stock_model': 'Ward stock model',
    'unit_dose_bills_each_issue_to_the_patient': 'Unit-dose bills each issue to the patient',
    'unit_dose_billed_per_issue': 'Unit dose (billed per issue)',
    'ward_stock_issued_to_the_ward': 'Ward stock (issued to the ward)',
    'medical_officers_orders_require_a_consultant_co': 'Medical officers\' orders require a consultant co-signature',
    'emr_forms': 'EMR forms',
    'emr_forms_description': 'Choose which forms doctors see in the EMR, in what order, and which must be filled before a visit is closed. Set them for all departments first, then adjust a department that works differently.',
    'emr_forms_visit_type': 'Visit type',
    'emr_forms_context_opd': 'OPD consultation',
    'emr_forms_context_ipd': 'IPD admission',
    'emr_forms_department': 'Department',
    'emr_forms_all_departments': 'All departments',
    'emr_forms_departments_of_branch': 'Departments of {branch}',
    'emr_forms_group_section': 'Sections',
    'emr_forms_group_section_hint': 'The parts of the consultation note, in the order doctors fill them',
    'emr_forms_group_ipd_form': 'IPD forms',
    'emr_forms_group_ipd_form_hint': 'Notes and orders written during a hospital stay',
    'emr_forms_group_order': 'Order forms',
    'emr_forms_group_order_hint': 'Tests, imaging and procedures ordered from the record',
    'emr_forms_group_clinical_form': 'Clinical forms',
    'emr_forms_group_clinical_form_hint': 'Structured forms. Each one still appears only for the patients it suits, whatever is set here',
    'emr_forms_enabled': 'Enabled',
    'emr_forms_required': 'Required',
    'emr_forms_state_optional': 'Optional',
    'emr_forms_state_hidden': 'Hidden',
    'emr_forms_move_up': 'Move {name} up',
    'emr_forms_move_down': 'Move {name} down',
    'emr_forms_inherits_all_departments': 'Inherits from All departments',
    'emr_forms_overridden': 'Overridden for this department',
    'emr_forms_standard': 'Standard setting',
    'emr_forms_changed': 'Changed from the standard',
    'emr_forms_reset_name': 'Reset {name}',
    'emr_forms_locked_hint': 'Always required. A visit cannot be closed without it.',
    'emr_forms_saved': 'EMR forms saved',
    'emr_forms_save': 'Save EMR forms',
    'emr_forms_could_not_load': 'Could not load the EMR forms',
    'emr_forms_could_not_save': 'Could not save the EMR forms',
    'emr_forms_discard': 'Discard changes',
    'emr_forms_reset_department': 'Reset department',
    'emr_forms_reset_department_title': 'Reset {department}?',
    'emr_forms_reset_department_body': 'Every form in {department} goes back to the All departments setting.',
    'emr_forms_reset_hospital': 'Reset to standard',
    'emr_forms_reset_hospital_title': 'Reset all departments to the standard forms?',
    'emr_forms_reset_hospital_body': 'Every form goes back to its standard setting. What was set for single departments stays as it is.',
    'emr_forms_reset_done': 'Reset to the inherited setting',
    'emr_forms_summary': '{shown} of {total} shown, {required} required',
    'emr_forms_hospital_wide_needs_access': 'Only staff with access to every branch can change the setting for all departments. Choose one of your departments.',
    'you_can_view_these_settings_but_not_change_them': 'You can view these settings but not change them.',
    'identity': 'Identity',
    'display_name': 'Display name',
    'primary_colour': 'Primary colour',
    'used_on_letterheads_and_the_app': 'Used on letterheads and the app',
    'language': 'Language',
    'english': 'English',
    'roman_urdu': 'Roman Urdu',
    'staff_sign_in_policy': 'Staff sign-in policy',
    'session_timeout_minutes': 'Session timeout (minutes)',
    'require_two_factor_sign_in_for_counter_and_back': 'Hospital policy: staff in administrator, counter and back-office roles must sign in with two-factor',
    'cashier_accountant_hr_officer_and_auditor_super': 'Applies to Cashier, Accountant, HR Officer and Auditor, plus Super Admins and Branch Admins. When it is off, each person decides for themselves. It does not turn your own authenticator on or off.',
    'own_two_factor_is_in_account_security': 'Your own two-factor sign-in is in Account → Security',
    'licensed_modules': 'Licensed modules',
    'modules_are_licensed_by_the_platform_owner': 'Modules are licensed by the platform owner. Contact them to change what your facility has.',
    'archived_no_longer_in_your_plan_still_readable': 'Archived — no longer in your plan, still readable',
    'could_not_export': 'Could not export',
    'raw_data_export_for_your_it_or_auditor': 'Raw data export, for your IT or auditor:',
    'support_access': 'Support access',
    'only_the_platform_owner_can_ever_sign_in_to': 'Only the platform Owner can ever sign in to this facility from outside it. Each session is read-only, cannot open clinical records, and is listed here.',
    'the_access_log_could_not_be_loaded': 'The access log could not be loaded.',
    'the_owner_has_never_signed_in_to_this_facility': 'The Owner has never signed in to this facility.',
    'as': 'as',
    'open_now': 'Open now',
    'ended_x': 'Ended {endedAt}',
    'update_scheduled': 'Update scheduled',
    'version_x_installs_at_x_everyone_signed_in_is': 'Version {version} installs at {at}. Everyone signed in is warned beforehand.',
    'could_not_schedule_the_update': 'Could not schedule the update',
    'scheduled_update_cancelled': 'Scheduled update cancelled',
    'could_not_cancel_the_schedule': 'Could not cancel the schedule',
    'installs_at': 'installs at',
    'required_scheduled_automatically': 'Required — scheduled automatically',
    'cancel_schedule': 'Cancel schedule',
    'schedule_version_x_for': 'Schedule version {version} for',
    'schedule_update': 'Schedule update',
    'version_x_verified': 'Version {version} verified',
    'apply_it_from_the_server_or_schedule_it': 'Apply it from the server, or schedule it.',
    'the_package_was_not_accepted': 'The package was not accepted',
    'update_from_a_file_lpk_up_to_4_gb': 'Update from a file (.lpk, up to 4 GB)',
    'uploading_x': 'Uploading {value}%',
    'upload_and_check': 'Upload and check',
    'rolling_back': 'Rolling back',
    'the_server_restarts_on_the_previous_version_in': 'The server restarts on the previous version in a few minutes.',
    'could_not_roll_back': 'Could not roll back',
    'go_back_to_the_previous_version': 'Go back to the previous version',
    'a_copy_of_the_current_database_is_saved_first': 'A copy of the current database is saved first. Then the previous version and the database from just before the last update are restored. Anything entered since that update stays in the saved copy — call support to bring it across.',
    'keep_this_version': 'Keep this version',
    'roll_back_and_restart': 'Roll back and restart',
    'everyone_signed_in_loses_their_connection_for_a': 'Everyone signed in loses their connection for a few minutes.',
    'refresh_the_update_log': 'Refresh the update log',
    'show_the_update_log': 'Show the update log',
    'no_update_has_been_run_on_this_server_yet': 'No update has been run on this server yet.',
    'update_now_cancel_and_roll_back_work_only_from': 'Update now, cancel and roll back work only from a browser on the server itself. From here you can schedule an update for a quiet time.',
    'roll_back_to_the_previous_version': 'Roll back to the previous version',
    'from_the_server_only': 'From the server only',
    'staff_and_roles': 'Staff & roles',
    'who_works_here_and_what_they_may_do': 'Who works here and what they may do',
    'add_user': 'Add user',
    'add_role': 'Add role',
    'users': 'Users',
    'roles': 'Roles',
    'search_by_name_email_or_phone': 'Search by name, email or phone',
    'filter_by_role': 'Filter by role',
    'every_role': 'Every role',
    'filter_by_branch': 'Filter by branch',
    'every_branch': 'Every branch',
    'no_staff_accounts_yet': 'No staff accounts yet.',
    'username': 'Username',
    'contact': 'Contact',
    'none': 'none',
    'licence_no': 'Licence no.',
    'missing': 'missing',
    '2fa': '2FA',
    'web_sign_in': 'Web sign-in',
    'allowed': 'allowed',
    'not_allowed': 'not allowed',
    'last_sign_in': 'Last sign-in',
    'locked_out': 'locked out',
    'permissions': 'Permissions',
    'x_can_no_longer_sign_in_on_the_web': '{name} can no longer sign in on the web',
    'x_can_sign_in_on_the_web': '{name} can sign in on the web',
    'could_not_change_web_sign_in': 'Could not change web sign-in',
    'allowed_2': 'Allowed',
    'not_allowed_2': 'Not allowed',
    'x_can_sign_in_again': '{name} can sign in again',
    'could_not_unlock_the_account': 'Could not unlock the account',
    'unlock': 'Unlock',
    'x_deleted': '{name} deleted',
    'could_not_delete_the_role': 'Could not delete the role',
    'x_is_back_to_the_standard': '{name} is back to the standard',
    'could_not_reset_the_role': 'Could not reset the role',
    'actions_for_x': 'Actions for {name}',
    'edit_permissions': 'Edit permissions',
    'duplicate': 'Duplicate',
    'reset_to_standard': 'Reset to standard',
    'that_role_is_still_in_use': 'That role is still in use',
    'x_staff_member_s_hold_it_move_them_to_another': '{userCount} staff member(s) hold it — move them to another role first.',
    'delete': 'Delete',
    'role_added': 'Role added',
    'loading_roles': 'Loading roles…',
    'archived': 'archived',
    'standard': 'standard',
    'custom': 'custom',
    'added': 'added',
    'removed_2': 'removed',
    'differs_from_standard': 'differs from standard',
    'staff_2': 'staff ·',
    'every_permission': 'every permission',
    'x_permissions': '{length} permissions',
    'always_has_everything_your_plan_includes': 'Always has everything your plan includes',
    'add_standard_role': 'Add standard role:',
    'role_updated': 'Role updated',
    'role_created': 'Role created',
    'add_a_role': 'Add a role',
    'what_this_role_may_do_and_how_far_its_reach_goes': 'What this role may do, and how far its reach goes',
    'still_needed': 'Still needed:',
    'create_role': 'Create role',
    'this_is_a_standard_role_you_can_change_which': 'This is a standard role. You can change which permissions it has; its name, reach and sign-in rules stay as standard. To change those, duplicate it. What you add or take away is remembered, and Reset to standard undoes it.',
    'fixed_once_the_role_exists': 'Fixed once the role exists',
    'optional_lowercase_no_spaces_made_from_the_name': 'Optional. Lowercase, no spaces — made from the name when left empty',
    'advanced_choose_the_role_code': 'Advanced: choose the role code',
    'description': 'Description',
    'how_far_it_reaches': 'How far it reaches',
    'what_the_holder_may_see_beyond_their_own_work': 'What the holder may see beyond their own work',
    'require_two_factor_sign_in': 'Require two-factor sign-in',
    'screens_this_role_works_in': 'Screens this role works in',
    'pick_the_modules_whose_screens_the_holder': 'Pick the modules whose screens the holder should see. Leave every one off to show all licensed modules.',
    'selected': 'selected)',
    'loading_the_catalogue': 'Loading the catalogue…',
    'all': 'all',
    'sensitive': 'sensitive',
    'x_created': '{name} created',
    'adjust_its_permissions_from_the_roles_list': 'Adjust its permissions from the roles list',
    'duplicate_x': 'Duplicate {name}',
    'the_copy_starts_with_the_same_permissions_and': 'The copy starts with the same permissions and is yours to change',
    'permissions_x': 'Permissions — {name}',
    'what_their_roles_grant_and_any_personal': 'What their roles grant, and any personal exception on top',
    'role': 'role',
    'inherit': 'Inherit',
    'grant': 'Grant',
    'deny': 'Deny',
    'granted': 'Granted',
    'denied': 'Denied',
    'reason_for_this_exception': 'Reason for this exception',
    'signature_saved': 'Signature saved',
    'it_prints_on_prescriptions_and_reports_this': 'It prints on prescriptions and reports this person signs',
    'could_not_save_the_signature': 'Could not save the signature',
    'signature_removed': 'Signature removed',
    'could_not_remove_the_signature': 'Could not remove the signature',
    'signature': 'Signature',
    'png_jpeg_or_webp_up_to_256_kb_printed_on': 'PNG, JPEG or WebP up to 256 KB. Printed on documents {name} signs.',
    'no_signature_yet': 'No signature yet',
    'uploading_x_2': 'Uploading… {value}%',
    'replace': 'Replace',
    'upload': 'Upload',
    'staff_member_updated': 'Staff member updated',
    'user_created': 'User created',
    'they_must_change_the_password_at_first_sign_in': 'They must change the password at first sign-in',
    'add_a_staff_member': 'Add a staff member',
    'changes_take_effect_the_next_time_they_load_a': 'Changes take effect the next time they load a page',
    'they_will_be_asked_to_change_the_password_when': 'They will be asked to change the password when they first sign in',
    'create_user': 'Create user',
    'full_name': 'Full name',
    'what_they_type_to_sign_in': 'What they type to sign in',
    'email': 'Email',
    'email_sending_title': 'Sending',
    'email_paused_title': 'Email sending is paused',
    'email_paused_daily': 'The daily limit on the platform mail server was reached on {date}. Queued emails are held, not lost. Sending does not restart by itself.',
    'email_paused_monthly': 'The monthly limit on the platform mail server was reached on {date}. Queued emails are held, not lost. Sending does not restart by itself.',
    'email_resume': 'Resume sending',
    'email_resume_wait': 'The limit is still used up. Sending can be resumed when the day or month starts again, or after the platform owner raises the limit.',
    'email_resume_super_admin': 'Only a Super Admin can resume sending.',
    'email_resumed': 'Email sending resumed',
    'email_resume_failed': 'Could not resume sending',
    'email_sends_through_tenant': 'Emails go through this facility’s own mail server.',
    'email_sends_through_owner': 'Emails go through the platform mail server, within the limits below.',
    'email_sends_nowhere': 'No mail server is available, so emails cannot be sent. Set one up below.',
    'email_fallback_off': 'The platform owner has turned off the platform mail server for this facility.',
    'email_used_today': 'Sent today through the platform',
    'email_used_month': 'Sent this month through the platform',
    'email_of_limit': '{used} of {limit}',
    'email_no_limit': '{used}, no limit',
    'email_smtp_title': 'Mail server (SMTP)',
    'email_smtp_hint': 'For Zoho Mail use smtppro.zoho.com, port 587, STARTTLS and an app password. This server is used before the platform mail server.',
    'email_host': 'Host',
    'email_port': 'Port',
    'email_encryption': 'Encryption',
    'email_encryption_starttls': 'STARTTLS (port 587)',
    'email_encryption_ssl': 'SSL/TLS (port 465)',
    'email_encryption_none': 'None',
    'email_username': 'User name',
    'email_app_password': 'App password',
    'email_password_stored': 'A password is stored. Leave blank to keep it.',
    'email_password_none': 'No password stored.',
    'email_password_clear': 'Clear',
    'email_password_keep': 'Keep',
    'email_password_cleared': 'Will be cleared on save.',
    'email_from_email': 'From address',
    'email_from_name': 'From name',
    'email_from_name_hint': 'Leave blank to use the facility name.',
    'email_save': 'Save mail server',
    'email_saved': 'Mail server saved',
    'email_save_failed': 'Could not save the mail server',
    'email_remove': 'Remove mail server',
    'email_removed': 'Mail server removed',
    'email_remove_confirm': 'Remove the mail server? Emails will go through the platform mail server, if it is available to this facility.',
    'email_test_to': 'Send a test to',
    'email_test_send': 'Send test email',
    'email_test_ok': 'Test email sent {date}',
    'email_test_failed': 'Test failed {date}: {error}',
    'email_test_never': 'Not tested yet.',
    'email_log_title': 'Email log',
    'email_log_empty': 'No emails yet.',
    'email_log_when': 'When',
    'email_log_to': 'To',
    'email_log_subject': 'Subject',
    'email_log_kind': 'Kind',
    'email_log_status': 'Status',
    'email_log_via': 'Sent through',
    'email_log_all': 'All',
    'email_status_sent': 'Sent',
    'email_status_failed': 'Failed',
    'email_status_skipped': 'Skipped',
    'email_via_tenant': 'Own server',
    'email_via_owner': 'Platform server',
    'email_kind_appointments': 'Appointments',
    'email_kind_results': 'Results and reports',
    'email_kind_billing': 'Billing and payments',
    'email_kind_staff_alerts': 'Staff alerts',
    'email_kind_messages': 'Messages',
    'email_kind_test': 'Test',
    'email_banner': 'Email sending is paused because the limit on the platform mail server was reached. Queued emails are held until sending is resumed.',
    'email_banner_open': 'Open email settings',
    'temporary_password': 'Temporary password',
    'generated_for_you_they_change_it_at_first_sign': 'Generated for you — they change it at first sign-in',
    'generate': 'Generate',
    'designation': 'Designation',
    'designation_other': 'Other (type it in)',
    'designation_hint': 'What the person does here. Choosing Doctor opens the clinical details.',
    'registration_licence_no': 'Registration / licence no.',
    'printed_on_prescriptions_certificates_and': 'Printed on prescriptions, certificates and reports',
    'registered_with': 'Registered with',
    'the_council_or_authority_that_issued_the_number': 'The council or authority that issued the number',
    'you_cant_change_your_own_roles_ask_another': 'You can\'t change your own roles. Ask another administrator.',
    'no_role_yet': 'No role yet',
    'role_2': 'Role',
    'choose_a_role': 'Choose a role',
    'all_branches': 'All branches',
    'choose_a_branch_2': 'Choose a branch',
    'temporary': 'Temporary?',
    'until': 'Until',
    'remove_this_role': 'Remove this role',
    'default_branch': 'Default branch',
    'where_this_person_usually_works_it_does_not': 'Where this person usually works. It does not limit what their roles reach.',
    'where_this_person_works_appointments_booked': 'Where this person works. Appointments booked with a doctor are filed under this department.',
    'history_of_this_account': 'History of this account',
    'money_authority_is_set_in_accounts': 'Money authority is set in Accounts →',
    'financial_authority': 'Financial authority',
    'this_person_is_a_doctor': 'This person is a doctor',
    'can_be_given_clinic_hours_and_appointment': 'Can be given clinic hours and appointment sessions, and write prescriptions',
    'printed_under_the_doctors_name_add_more_under': 'Printed under the doctor\'s name. Add more under Branches & departments.',
    'wards_and_beds': 'Wards & beds',
    'add_ward': 'Add ward',
    'add_a_ward': 'Add a ward',
    'create_ward': 'Create ward',
    'add_room': 'Add room',
    'add_a_room_to_x': 'Add a room to {name}',
    'create_room': 'Create room',
    'add_bed': 'Add bed',
    'add_a_bed_to_room_x': 'Add a bed to room {code}',
    'edit_bed_x': 'Edit bed {code}',
    'create_bed': 'Create bed',
    'room': 'Room',
    'bed_class': 'Bed class',
    'default_bed_class': 'Default bed class',
    'daily_charge': 'Daily charge',
    'no_daily_charge': 'No daily charge',
    'nurse_station_phone': 'Nurse-station phone',
    'in_service': 'In service',
    'bed_x_in_service': 'Bed {code} in service',
    'bed_x_retired': 'Bed {code} retired',
    'retired_beds_leave_the_bed_board_and_this_list': 'Retired beds leave the bed board and this list.',
    'retiring_a_bed_removes_it_from_the_bed_board': 'Retiring a bed removes it from the bed board and from this list. An occupied bed cannot be retired.',
    'could_not_change_the_bed': 'Could not change the bed',
    'retired_beds_stay_here_greyed': 'Retired beds leave the bed board. They stay here, greyed, until they are put back in service.',
    'retiring_a_bed_takes_it_off_the_bed_board': 'Retiring a bed takes it off the bed board; it stays here so it can be put back. An occupied bed cannot be retired.',
    'retire_bed_x': 'Retire bed {code}?',
    'retire_bed_x_confirm': 'Bed {code} leaves the bed board and cannot take an admission until it is put back in service. It stays on this list, greyed.',
    'retire_bed': 'Retire bed',
    'bed_x_back_in_service': 'Bed {code} is back in service',
    'bed_retired': 'Retired',
    'no_wards_yet': 'No wards yet',
    'no_wards_yet_hint': 'Add a ward, then its rooms and beds. The bed board and admissions use what is set here.',
    'no_rooms_yet_add_one_to_place_beds': 'No rooms yet. Add one to place beds in it.',
    'no_beds_in_this_room_yet': 'No beds in this room yet.',
    'x_rooms_y_beds': '{rooms} rooms · {beds} beds',
    'ward_created': 'Ward created',
    'ward_updated': 'Ward updated',
    'room_created': 'Room created',
    'bed_created': 'Bed created',
    'bed_updated': 'Bed updated',
    'short_code_unique_within_the_branch': 'Short code, unique within the branch',
    'short_code_unique_within_the_ward': 'Short code, unique within the ward',
    'short_code_unique_within_the_room': 'Short code, unique within the room',
    'fixed_once_created': 'Fixed once created',
    'the_admitting_department_of_the_ward_optional': 'The admitting department of the ward (optional)',
    'new_beds_in_this_ward_start_with_this_class': 'New beds in this ward start with this class',
    'rung_by_the_laboratory_when_a_critical_result': 'Rung by the laboratory when a critical result cannot reach the doctor',
    'optional_name_such_as_bay_a': 'Optional name, such as “Bay A”',
    'the_daily_bed_charge_is_posted_to_every': 'The daily bed charge is posted to every admission in this bed. Pick it from the bed category of Services & prices.',
    'current_charge_outside_the_bed_category': 'Current charge (outside the bed category)',
    'no_bed_charges_yet_add_one_under_services': 'No bed charges yet. Add one under Services & prices with the category “bed”.',
    'set': 'Set',
    'people': 'People',
    'everyone_who_works_here_with_or_without_a_login': 'Everyone who works here, with or without a login',
    'add_person': 'Add person',
    'add_a_person': 'Add a person',
    'rosters': 'Rosters',
    'attendance': 'Attendance',
    'leave': 'Leave',
    'payroll': 'Payroll',
    'login': 'Login',
    'hr_record': 'HR record',
    'no_people_yet': 'No people yet.',
    'search_by_name_username_or_employee_number': 'Search by name, username or employee number',
    'doctor': 'Doctor',
    'bookable': 'Bookable',
    'clinical': 'Clinical',
    'employment': 'Employment',
    'never': 'never',
    'expired': 'expired',
    'loading_this_person': 'Loading this person…',
    'this_person_signs_in': 'This person signs in',
    'create_login': 'Create login',
    'a_login_lets_them_open_the_system_leave_it_off': 'A login lets them open the system. Leave it off for staff who are only rostered and paid.',
    'a_login_or_an_hr_record': 'a login or an HR record',
    'can_be_booked_for_appointments': 'Can be booked for appointments',
    'shown_in_the_booking_screens_and_the_calendar': 'Shown in the booking screens and the calendar',
    'the_hr_record_is_separate_from_the_login': 'Separate from the login: locums and support staff are paid without ever signing in',
    'has_an_hr_record': 'Has an HR record',
    'contract_pay_registration_expiry_rosters_and_leave': 'Contract, pay, registration expiry, rosters and leave',
    'link_an_existing_hr_record': 'Link an existing HR record',
    'link': 'Link',
    'choose_an_hr_record': 'Choose an HR record…',
    'no_unlinked_hr_records': 'No unlinked HR records.',
    'hr_record_linked': 'HR record linked',
    'could_not_link_the_hr_record': 'Could not link the HR record',
    'employee_no': 'Employee no.',
    'left_empty_the_next_number_in_the_series_is_used': 'Left empty, the next number in the series is used',
    'contract': 'Contract',
    'joined_on': 'Joined on',
    'contract_ends': 'Contract ends',
    'national_id': 'National ID / CNIC',
    'basic_salary': 'Basic salary',
    'registration_number': 'Registration number',
    'pmdc_nursing_council': 'PMDC, nursing council',
    'registration_expiry': 'Registration expiry',
    'bank_account': 'Bank account',
    'person_created': 'Person created',
    'person_updated': 'Person updated',
    'x_professional_registration_s_have_expired': '{count} professional registration(s) have expired',
    'x_registration_s_expire_within_90_days': '{count} registration(s) expire within 90 days',
    'roster': 'Roster',
    'shift': 'Shift',
    'location': 'Location',
    'opening_hours': 'Opening hours',
    'documents': 'Documents',
    'bed': 'Bed',
    'account_actions': 'Account actions',
    'confirm': 'Confirm',
    'step_up_hint': 'Confirm with the code from your authenticator',
    'deactivate_x': 'Deactivate {name}?',
    'deactivate_body': 'They are signed out everywhere and cannot sign in until reactivated. Their records stay.',
    'reactivate_x': 'Reactivate {name}?',
    'reactivate_body': 'They can sign in again with their existing password.',
    'x_deactivated': '{name} deactivated',
    'x_reactivated': '{name} reactivated',
    'could_not_change_the_account': 'Could not change the account',
    'reset_password': 'Reset password',
    'reset_password_x': 'Reset the password of {name}',
    'reset_password_body': 'They sign in with this temporary password and must choose their own at once. It is shown only once.',
    'type_your_own': 'Type your own',
    'password_reset': 'Password reset',
    'tell_x_the_temporary_password': 'Tell {name} the temporary password; it is not shown again.',
    'could_not_reset_the_password': 'Could not reset the password',
    'force_sign_out': 'Force sign-out',
    'force_sign_out_x': 'Sign {name} out everywhere?',
    'force_sign_out_body': 'Every device is signed out within seconds. They can sign in again straight away.',
    'x_signed_out_everywhere': '{name} signed out everywhere ({count} session(s) ended)',
    'could_not_sign_out_the_user': 'Could not sign the user out',
    'enable_2fa': 'Enable 2FA',
    'enable_2fa_x': 'Enable two-factor sign-in for {name}',
    'enable_2fa_body': 'They are signed out and set up an authenticator app themselves at their next sign-in, then use its code every time.',
    'two_factor_enabled_for_x': 'Two-factor sign-in enabled for {name}',
    'show_this_key_to_x_once': 'Show this key to {name} now — it is not shown again.',
    'reset_2fa': 'Reset 2FA',
    'reset_2fa_x': 'Reset the authenticator of {name}?',
    'reset_2fa_body': 'Their authenticator stops working and they are signed out. If their role requires two-factor sign-in, they enrol a new one at their next sign-in.',
    'two_factor_reset_for_x': 'Authenticator reset for {name}',
    'could_not_change_two_factor': 'Could not change two-factor sign-in',
    'secret_key': 'Secret key',
    'open_in_authenticator_app': 'Open in authenticator app',
    'sessions': 'Sessions & devices',
    'sessions_x': 'Sessions of {name}',
    'no_active_sessions': 'No active sessions.',
    'signed_in': 'Signed in',
    'last_seen': 'Last seen',
    'device': 'Device',
    'unknown_device': 'Unknown device',
    'revoke': 'Revoke',
    'session_ended': 'Session ended',
    'could_not_end_the_session': 'Could not end the session',
    'login_history': 'Login history',
    'login_history_x': 'Last sign-ins of {name}',
    'no_sign_ins_recorded': 'No sign-ins recorded yet.',
    'outcome': 'Outcome',
    'succeeded': 'Succeeded',
    'failed_2': 'Failed',
    'users_exported': 'Users exported',
    'could_not_export_users': 'Could not export the users',
    'branch_status_approved': 'Approved',
    'branch_status_rejected': 'Rejected',
    'branch_waiting_for_owner_title': 'Waiting for the platform owner',
    'branch_waiting_for_owner_body': 'A new branch stays closed to sign-in until the platform owner approves it. You can already set it up and add its staff; the decision shows here.',
    'branch_rejected_reason': 'Reason: {reason}',
    'branch_rejected_next_step': 'Fix what the reason asks for with Edit, then send it again.',
    'send_branch_again': 'Send again',
    'branch_sent_again': 'Sent to the platform owner again',
    'could_not_send_branch_again': 'Could not send the branch again',
    'owner_mail_title': 'Mail',
    'owner_mail_description': 'The owner mailbox, read with the email (SMTP) user and password saved in Alerts. Nothing is checked in the background; press Refresh to look for new mail.',
    'owner_mail_new_mail': 'New mail',
    'owner_mail_reply': 'Reply',
    'owner_mail_sent_from_owner_mailbox': 'Sent from the owner mailbox set up in Alerts, Settings.',
    'owner_mail_cancel': 'Cancel',
    'owner_mail_send': 'Send',
    'owner_mail_to': 'To',
    'owner_mail_cc': 'Cc',
    'owner_mail_subject': 'Subject',
    'owner_mail_message': 'Message',
    'owner_mail_not_an_address': 'Not an email address: {list}',
    'owner_mail_add_recipient': 'Add at least one recipient.',
    'owner_mail_too_many_recipients': 'At most {count} recipients in each box.',
    'owner_mail_sent': 'Mail sent',
    'owner_mail_send_failed': 'The mail could not be sent',
    'owner_mail_unknown_sender': 'Unknown sender',
    'owner_mail_attachment_failed': 'Could not download the attachment',
    'owner_mail_no_subject': '(no subject)',
    'owner_mail_from_x': 'From {sender}',
    'owner_mail_to_x': 'To {list}',
    'owner_mail_cc_x': 'Cc {list}',
    'owner_mail_too_large': 'This message is larger than 20 MB, so only its details are shown. Open it in the mailbox itself.',
    'owner_mail_attachment_too_large': 'Too large to download here',
    'owner_mail_download_x': 'Download {name}',
    'owner_mail_refresh_failed': 'Could not refresh the mailbox',
    'owner_mail_wrote': 'On {when}, {sender} wrote:',
    'owner_mail_folder': 'Folder',
    'owner_mail_refresh': 'Refresh',
    'owner_mail_count_read_at': '{count} messages · read {when}',
    'owner_mail_try_again': 'Try again',
    'owner_mail_opening': 'Opening the mailbox…',
    'owner_mail_empty_folder': 'No messages here.',
    'owner_mail_unread': 'Unread',
    'owner_mail_has_attachment': 'Has an attachment',
    'owner_mail_newer': 'Newer',
    'owner_mail_older': 'Older',
    'owner_mail_page_of': 'Page {page} of {pages}',
    'owner_mail_choose_message': 'Choose a message to read it.',
    'alert_email_tab': 'Email rules',
    'alert_email_saved': 'Alert email rules saved',
    'alert_email_save_failed': 'Could not save the alert email rules',
    'alert_email_loading': 'Loading the email rules…',
    'alert_email_route_owner': 'Owner only',
    'alert_email_route_customer': 'Customer only',
    'alert_email_route_both': 'Owner and customer',
    'alert_email_route_none': 'No email',
    'alert_email_mute_1_day': '1 day',
    'alert_email_mute_7_days': '7 days',
    'alert_email_mute_30_days': '30 days',
    'alert_email_mute_forever': 'Until unmuted',
    'alert_email_smtp_missing': 'The email (SMTP) server is not saved yet, so no alert email can be sent. Set it in Alerts, Settings.',
    'alert_email_title': 'Who gets each alert by email',
    'alert_email_description': 'Customer means the facility contact person and its Super Admins, emailed from the owner mailbox. Counts cover the last {days} days.',
    'alert_email_enabled': 'Send alert emails',
    'alert_email_enabled_hint': 'Off stops every alert email. Alerts are still recorded in the feed, and SMS is not affected.',
    'alert_email_owner_addresses': 'Owner addresses: {list}',
    'alert_email_column_alert': 'Alert',
    'alert_email_column_send_to': 'Send to',
    'alert_email_column_repeat_hours': 'Repeat window (hours)',
    'alert_email_column_sent': 'Emailed',
    'alert_email_column_held': 'Held back',
    'alert_email_repeat_hint': 'The same alert for the same facility is emailed once per window; 0 sends it every time. Up to {max} hours.',
    'alert_email_muted_title': 'Muted facilities',
    'alert_email_muted_description': 'No alert email is sent for a muted facility. Its alerts still appear in the feed.',
    'alert_email_no_mutes': 'No facility is muted.',
    'alert_email_muted_until': 'Until {when}',
    'alert_email_unmute': 'Unmute',
    'alert_email_facility': 'Facility',
    'alert_email_choose_facility': 'Choose a facility',
    'alert_email_mute_for': 'Mute for',
    'alert_email_mute': 'Mute',
    'alert_email_save': 'Save email rules',
    'person_branch_x': 'Branch: {name}',
    'new_people_join_the_branch_you_work_in': 'New people are added to the branch you are working in. Switch branch from the top bar to add someone elsewhere.',
    'departments_of_this_branch_hint': 'Departments of this branch. The first one chosen is the main department; appointments booked with a doctor are filed under it.',
    'a_department_for_someone_who_takes_appointments': 'a department (they take appointments)',
    'needed_to_set_clinic_hours': 'Needed to set this person\'s clinic hours',
    'add_a_department_to_this_branch_first': 'This person takes appointments, so they need a department, but this branch has none yet. Add a department under Branches first.',
    'choose_departments': 'Choose departments',
    'person_x_departments': '{count} departments',
    'main_department': 'Main',
    'a_doctor_needs_a_login_to_be_booked': 'a login (a doctor cannot be booked without one)',
    'this_branch_has_no_departments_yet': 'This branch has no departments yet',
    'one_department_without_a_login': 'Without a login a person can have one department. Turn the login on to choose several.',
    'support_ambulance': 'Ambulance',
    'support_ambulance_hint': 'Fleet, dispatch and trip log',
    'support_dispatch': 'Dispatch',
    'support_vehicles': 'Vehicles',
    'support_out_on_a_trip': 'Out on a trip',
    'support_trips_logged': 'Trips logged',
    'support_no_trips_logged': 'No trips logged.',
    'support_vehicle': 'Vehicle',
    'support_driver': 'Driver',
    'support_trip_from': 'From',
    'support_trip_to': 'To',
    'support_started': 'Started',
    'support_distance': 'Distance',
    'support_distance_km': '{distance} km',
    'support_charge': 'Charge',
    'support_trip_billed': 'billed',
    'support_trip_closed_badge': 'closed',
    'support_on_trip': 'on trip',
    'support_end_trip': 'End trip',
    'support_end_the_trip': 'End the trip',
    'support_close_trip': 'Close trip',
    'support_distance_km_label': 'Distance (km)',
    'support_bill_trip_to_patient': 'Bill this trip to the patient',
    'support_trip_closed': 'Trip closed',
    'support_could_not_close_trip': 'Could not close the trip',
    'support_kitchen_sheet': 'Kitchen sheet',
    'support_kitchen_sheet_hint': 'Every in-patient, their diet and their allergies',
    'support_all_wards': 'All wards',
    'support_no_inpatients_to_feed': 'No in-patients to feed.',
    'support_patient': 'Patient',
    'support_diet': 'Diet',
    'support_allergies': 'Allergies',
    'support_note': 'Note',
    'support_housekeeping': 'Housekeeping',
    'support_housekeeping_hint': 'Bed cleaning, linen and the rest of the ward round',
    'support_all': 'All',
    'support_nothing_outstanding': 'Nothing outstanding.',
    'support_task': 'Task',
    'support_raised': 'Raised',
    'support_start': 'Start',
    'support_done': 'Done',
    'support_bed_back_on_board': 'Done — the bed is back on the board',
    'support_updated': 'Updated',
    'support_could_not_update_task': 'Could not update the task',
    'support_feedback_and_complaints': 'Feedback & complaints',
    'support_feedback_hint_patients': 'What patients said, and what was done about it',
    'support_feedback_hint_customers': 'What customers said, and what was done about it',
    'support_log_a_complaint': 'Log a complaint',
    'support_feedback': 'Feedback',
    'support_complaints': 'Complaints',
    'support_net_promoter_score': 'Net promoter score',
    'support_last_30_days': 'Last 30 days',
    'support_responses': 'Responses',
    'support_promoters': 'Promoters',
    'support_detractors': 'Detractors',
    'support_no_feedback_30_days': 'No feedback in the last 30 days.',
    'support_source': 'Source',
    'support_nps': 'NPS',
    'support_rating': 'Rating',
    'support_comment': 'Comment',
    'support_no_complaints_logged': 'No complaints logged.',
    'support_subject': 'Subject',
    'support_sla': 'SLA',
    'support_sla_breached': 'breached',
    'support_resolution': 'Resolution',
    'support_resolve': 'Resolve',
    'support_resolve_the_complaint': 'Resolve the complaint',
    'support_what_was_done': 'What was done?',
    'support_resolution_required': 'A complaint cannot be closed without this',
    'support_complaint_resolved': 'Complaint resolved',
    'support_could_not_resolve': 'Could not resolve it',
    'support_tasks': 'Tasks',
    'support_tasks_hint': 'Who is doing what, and by when',
    'support_assign_a_task': 'Assign a task',
    'support_assigned_to': 'Assigned to',
    'support_mine': 'Mine',
    'support_everyone': 'Everyone',
    'support_nothing_on_your_list': 'Nothing on your list.',
    'support_priority': 'Priority',
    'support_due': 'Due',
    'support_task_updated': 'Task updated',
    'roster_ward_whole_department': 'Whole department (no ward)',
    'roster_ward_hint': 'Staff on a ward shift receive that ward’s alerts. Without a ward, the shift covers the department’s wards that have nobody rostered.',
    'dept_phrases_title': 'Quick-pick phrases',
    'dept_phrases_hint': 'Phrases this department offers its doctors under the note fields',
    'dept_phrases_count': '{count, plural, one {# phrase} other {# phrases}} set for this department',
    'dept_phrases_pick_department': 'Pick a department above to set the phrases its doctors are offered',
    'dept_phrases_edit': 'Edit phrases',
    'dept_phrases_view': 'View phrases',
    'dept_phrases_screen_hint': 'Shown first under each note field for doctors of {department}, before their own phrases and the standard ones',
    'dept_phrases_used': '{count} of {max}',
    'dept_phrases_none': 'No phrases for this field',
    'dept_phrases_remove': 'Remove “{phrase}”',
    'dept_phrases_add_placeholder': 'Type a phrase and press Enter',
    'dept_phrases_add_to': 'Add a phrase to {field}',
    'dept_phrases_add': 'Add',
    'dept_phrase_empty': 'Type a phrase first',
    'dept_phrase_too_long': 'A phrase can be at most {max} characters',
    'dept_phrase_duplicate': 'That phrase is already in the list',
    'dept_phrase_full': 'A field can hold at most {max} phrases',
    'dept_phrases_saved': 'Phrases saved',
    'dept_phrases_save': 'Save phrases',
    'dept_phrases_not_found': 'That department could not be found',
    'qp_field_chiefComplaint': 'Chief complaint',
    'qp_field_presentingComplaints': 'Presenting complaints',
    'qp_field_historyOfPresentIllness': 'History of present illness',
    'qp_field_pastHistory': 'Past medical history',
    'qp_field_surgicalHistory': 'Surgical history',
    'qp_field_familyHistory': 'Family history',
    'qp_field_socialHistory': 'Social history',
    'qp_field_drugHistory': 'Drug history',
    'qp_field_reviewOfSystems': 'Review of systems',
    'qp_field_examination': 'Examination',
    'qp_field_treatmentPlan': 'Treatment plan',
    'qp_field_advice': 'Advice',
    'mrd_kind_discharge_summary': 'Discharge summary unsigned',
    'mrd_kind_operative_note': 'Operative note missing',
    'mrd_kind_coding': 'Not coded',
    'mrd_title': 'Medical records',
    'mrd_description': 'What is unfinished, what is coded, and who asked for a copy',
    'mrd_log_request': 'Log a request',
    'mrd_tab_worklist': 'Worklist',
    'mrd_tab_requests': 'Record requests',
    'mrd_tab_retention': 'Retention',
    'mrd_unfinished_records': 'Unfinished records',
    'mrd_unsigned_summaries': 'Unsigned summaries',
    'mrd_uncoded_episodes': 'Uncoded episodes',
    'mrd_older_than_week': 'Older than a week',
    'mrd_nothing_outstanding': 'Nothing outstanding — every closed record is complete.',
    'mrd_issue': 'Issue',
    'mrd_reference': 'Reference',
    'mrd_patient': 'Patient',
    'mrd_responsible': 'Responsible',
    'mrd_age': 'Age',
    'mrd_age_days': '{days} d',
    'mrd_episode_coded': 'Episode coded',
    'mrd_icd_coding': 'ICD coding',
    'mrd_save_coding': 'Save coding',
    'mrd_coding_replaces': 'Saving replaces any previous coding for this episode.',
    'mrd_search_icd': 'Search ICD-10',
    'mrd_search_icd_placeholder': 'Code or diagnosis text',
    'mrd_nothing_selected': 'Nothing selected yet.',
    'mrd_request_updated': 'Request updated',
    'mrd_all': 'All',
    'mrd_no_requests': 'No record requests.',
    'mrd_logged': 'Logged',
    'mrd_requested_by': 'Requested by',
    'mrd_as': 'As',
    'mrd_purpose': 'Purpose',
    'mrd_consent': 'Consent',
    'mrd_none': 'None',
    'mrd_release': 'Release',
    'mrd_release_title': 'Release the record',
    'mrd_release_description': 'Consent is the only thing between the records desk and a stranger reading a diagnosis',
    'mrd_refuse': 'Refuse',
    'mrd_consent_reference': 'Consent reference',
    'mrd_consent_reference_hint': 'Signed consent form number or file reference',
    'mrd_retention_policy': 'Retention policy',
    'mrd_retention_years': '{years} years',
    'mrd_cutoff': 'Cutoff',
    'mrd_admissions_past_retention': 'Admissions past retention',
    'mrd_episodes_past_retention': 'Episodes past retention',
    'mrd_oldest_record': 'Oldest record on file: {date}.',
    'phone_number_length': 'Enter {min} to {max} digits. Only a leading + and digits are allowed.',
};
//# sourceMappingURL=admin.js.map